import React from 'react';
import { connect } from 'react-redux';
import { getConferenceState } from '../../base/conference/functions';
import { translate } from '../../base/i18n/functions';
import { IconE2EE } from '../../base/icons/svg';
import Label from '../../base/label/components/web/Label';
import { COLORS } from '../../base/label/constants';
import Tooltip from '../../base/tooltip/components/Tooltip';
import { getLocalAuthenticationStatus, isAuthKeyRoomE2EEEnabled, isExternallyManagedAuthKey } from '../functions';
const E2EELabel = ({ _e2eeLabels, _showLabel, t }) => {
    if (!_showLabel) {
        return null;
    }
    const content = _e2eeLabels?.tooltip || t('e2ee.labelToolTip');
    return (React.createElement(Tooltip, { content: content, position: 'bottom' },
        React.createElement(Label, { color: COLORS.green, icon: IconE2EE })));
};
/**
 * Maps (parts of) the redux state to the associated props of this {@code Component}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {IProps}
 */
export function _mapStateToProps(state) {
    const { e2ee = {} } = state['features/base/config'];
    const { enabled: localE2eeEnabled } = state['features/e2ee'];
    const { numberOfParticipantsDisabledE2EE } = state['features/base/participants'];
    const conference = getConferenceState(state).conference;
    const conferenceE2eeEnabled = Boolean(conference?.isE2EEEnabled?.());
    const roomE2eeEnabled = isAuthKeyRoomE2EEEnabled(state);
    let _showLabel = numberOfParticipantsDisabledE2EE === 0;
    if (isExternallyManagedAuthKey(state)) {
        _showLabel = Boolean(localE2eeEnabled
            || getLocalAuthenticationStatus()
            || conferenceE2eeEnabled
            || roomE2eeEnabled);
    }
    return {
        _e2eeLabels: e2ee.labels,
        _showLabel
    };
}
export default translate(connect(_mapStateToProps)(E2EELabel));
